import React, { CSSProperties, useCallback } from 'react';
import { Form, Stack } from 'rsuite';
import {
  CheckboxWithErrorStatus,
  CheckboxWithErrorStatusProps,
} from '../common/CheckboxWithErrorStatus';
import type { CheckType } from 'schema-typed';

interface AnnotatedCheckboxProps {
  title?: string;
  label: string;
  name: string;
  value: boolean;
  onChange: (value: boolean) => void;
  style?: CSSProperties;
  hasError?: boolean;
  validationRule?: CheckType<boolean, string>;
}

const AnnotatedCheckbox = ({
  title,
  label,
  name,
  validationRule,
  style,
  hasError,
  ...rest
}: AnnotatedCheckboxProps) => {
  const CheckboxWithErrorStateAndProps = useCallback(
    (props: CheckboxWithErrorStatusProps) => (
      <CheckboxWithErrorStatus
        {...props}
        showError={hasError}
      />
    ),
    [hasError]
  );

  return (
    <Form.Group
      controlId={name}
      style={style}
    >
      {title && <Form.ControlLabel>{title}</Form.ControlLabel>}

      <Stack
        className="mt-8"
        direction="column"
        alignItems="flex-start"
      >
        <Stack.Item>
          <Stack
            direction="row"
            alignItems="center"
            spacing={4}
          >
            <Stack.Item>
              <Form.Control
                accepter={CheckboxWithErrorStateAndProps}
                name={name}
                checkTrigger="none"
                rule={validationRule}
                {...rest}
              />
            </Stack.Item>
            <Stack.Item className="mt-4">
              <Form.ControlLabel id={`${name}-label`}>
                {label}
              </Form.ControlLabel>
            </Stack.Item>
          </Stack>
        </Stack.Item>
      </Stack>
    </Form.Group>
  );
};

export default AnnotatedCheckbox;
